export const medicalList = {
  treatmentsOptions: [//治疗项目

  ],
  appointmentOptions: [],
  remindList: [{ //预约提醒
    label: "流失",
    value: 0,
  }, {
    label: "无人接听",
    value: 1,
  }, {
    label: "已到店",
    value: 2,
  }],
  patientOptions: [//患者来源
    {
      label: "线上预约",
      value: 0
    },
    {
      label: "朋友介绍",
      value: 1
    },
    {
      label: "附近居住",
      value: 2
    },
    {
      label: "腾讯健康",
      value: 3
    },
    {
      label: "微笑吧",
      value: 4
    },
    {
      label: "其他",
      value: 5
    },
    {
      label: "小程序用户",
      value: 6
    },
  ],
  patientPhaseOptions: [
    //患者阶段
    {
      label: "初诊",
      value: 0,
    }, {
      label: "复诊",
      value: 1,
    }
  ]
}
export default medicalList;
